import { createPinia } from 'pinia';

const Store = createPinia();

export default Store;
